import { createAction } from 'redux-actions';
import * as Actions from '../constants/actions';
import { StoryData, StoryInfo, SelectedStory } from '../models/Story';

export const addStory = createAction<StoryData>(Actions.STORY_ADD);
export const deleteStory = createAction<StoryInfo>(Actions.STORY_DELETE);
export const setStories = createAction<StoryData[]>(Actions.SET_STORIES);
export const markGradedStory = createAction<StoryInfo>(Actions.STORY_MARK_GRADED);
export const markImportantStory = createAction<StoryInfo>(Actions.STORY_MARK_IMPORTANT);

export const setSelectedStory = createAction<SelectedStory>(Actions.SET_SELECTED_STORY);


// WEBPACK FOOTER //
// ./~/tslint-loader!./react/narrapix/src/actions/story.ts